/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {
  'use strict';

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.idspThemeBanner = {
    attach: function (context, settings) {
      var self = this;
      var $context = $(context);
      var $body = $('body');
      var analyticsConsent = localStorage.getItem('analyticsConsent');
      var preferenceConsent = localStorage.getItem('preferenceConsent');
      var consentGiven = localStorage.getItem('consentGiven');

      self.selectors = {
        breadcrumb: '.idsk-header-web__nav-bar--breadcrumbs .govuk-breadcrumbs__list',
        navItem: '.idsk-header-web__nav-list-item',
        subnavItem: '.idsk-header-web__subnav-list-item',
        link: '.idsk-header-web__nav-list-item-link'
      };

      var $acceptAll = $context.find('#consent-accept-all').once('header');
      var $declineAll = $context.find('#consent-decline-all').once('header');
      var $analyticsCheckbox = $context.find('#edit-analytics-consent-checkbox');
      var $preferenceCheckbox = $context.find('#edit-preference-consent-checkbox');
      var $consentBanner = $context.find('.idsp-consent-banner');
      var $saveButton = $context.find('#consent-page-button');

      $saveButton.on('click', function(e) {
        e.preventDefault();
        var analyticsChecked = $analyticsCheckbox.is(":checked");
        var preferenceChecked = $preferenceCheckbox.is(":checked");
        var analyticsStatus = analyticsChecked === true ? '1' : '0';
        var preferenceStatus = preferenceChecked === true ? '1' : '0';
        localStorage.setItem('consentGiven', '1');
        localStorage.setItem('analyticsConsent', analyticsStatus);
        localStorage.setItem('preferenceConsent', preferenceStatus);
      });

      if($consentBanner) {
        if(!consentGiven || consentGiven === null) {
          $consentBanner.removeClass('hidden');
        }
      }

      if($analyticsCheckbox) {
        if(analyticsConsent === '1') {
          $analyticsCheckbox.prop('checked', true);
        }

      }

      if($preferenceCheckbox) {
        if(preferenceConsent === '1') {
          $preferenceCheckbox.prop("checked", true);
        }
      }

      $acceptAll.on('click', function (e) {
        localStorage.setItem('analyticsConsent', '1');
        localStorage.setItem('preferenceConsent', '1');
        localStorage.setItem('consentGiven', '1');
        $consentBanner.addClass('hidden');

      });

      $declineAll.on('click', function(e) {
        localStorage.setItem('analyticsConsent', '0');
        localStorage.setItem('preferenceConsent', '0');
        localStorage.setItem('consentGiven', '1');
        $consentBanner.addClass('hidden');

      });
    }
  };

})(Drupal, jQuery);
